// middleware/redirect.js
export default defineNuxtRouteMiddleware((to, from) => {
  // Check the route you want to redirect from
  if (to.path === '/restricted-page') {
    // Redirect to a different page
    return navigateTo('/another-page')
  }
})
